"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PATIENT_TO_FHIR_MAPPING = void 0;
exports.PATIENT_TO_FHIR_MAPPING = [
    { patientDtoField: 'uhid', fhirPath: 'identifier[?system=urn:nexao:uhid].value' },
    { patientDtoField: 'givenName', fhirPath: 'name[0].given[0]' },
    { patientDtoField: 'familyName', fhirPath: 'name[0].family' },
    { patientDtoField: 'dateOfBirth', fhirPath: 'birthDate' },
    {
        patientDtoField: 'dateOfBirthPrecision',
        fhirPath: '(none — FHIR birthDate precision is inferred from the date string\'s length, not a separate field)',
        notes: 'YEAR_ONLY maps to a bare "1990" birthDate string; ESTIMATED has no direct FHIR R4 equivalent — the `_birthDate.extension` "patient-birthTime"-style extension would be the realistic target.',
    },
    { patientDtoField: 'genderId', fhirPath: 'gender', notes: 'Requires a LookupValue -> FHIR AdministrativeGender code mapping table, not built yet (LookupValue is tenant-configurable; FHIR gender is a fixed 4-value enum).' },
    { patientDtoField: 'status', fhirPath: 'active', notes: 'FHIR active is boolean; ACTIVE -> true, INACTIVE/MERGED/DECEASED/BLOCKED -> false — lossy in one direction, deliberately: FHIR has no single field for NEXAO\'s 5-state lifecycle.' },
    { patientDtoField: 'dateOfDeath', fhirPath: 'deceasedDateTime' },
    { patientDtoField: 'mergedIntoPatientId', fhirPath: 'link[?type=replaced-by].other.reference' },
];
//# sourceMappingURL=fhir-mapping.types.js.map